import React from "react";
import Footer from "../components/Footer";

import { useTranslation } from "react-i18next";

const PrivacyPolicy = () => {
  const { t } = useTranslation();
  return (
    <div className="container mx-auto">
      <div className="mt-10 mb-10 font-bold text-xl">
        {t("privacy_policy1")}
      </div>
      <div>{t("privacy_policy2")}</div>
      <br />
      <div>{t("privacy_policy3")}</div>
      <br />
      <div>{t("privacy_policy4")}</div>
      <br />
      <div className="mb-10 font-bold text-xl">{t("privacy_policy5")}</div>
      <div>{t("privacy_policy6")}</div>
      <div className="mt-10 mb-10 font-bold text-xl">
        {t("privacy_policy7")}
      </div>
      <div>{t("privacy_policy8")}</div>
      <div className="mt-10 mb-10 font-bold text-xl">
        {t("privacy_policy9")}
      </div>
      <div>{t("privacy_policy10")}</div>
      <br />
      <div className="mb-10 font-bold text-xl">{t("privacy_policy_deletion")}</div>
      <div>{t("privacy_policy_deletion1")}</div>
      <div>{t("privacy_policy_deletion2")}</div>
      <div>{t("privacy_policy_deletion3")}</div>
      <div className="mt-10 mb-10 font-bold text-xl">
        {t("privacy_policy11")}
      </div>
      <div>
        {t("privacy_policy12")}
        <ul className="list-disc">
          <li>{t("privacy_policy13")}</li>
          <li>{t("privacy_policy14")}</li>
          <li>{t("privacy_policy15")}</li>
          <li>{t("privacy_policy16")}</li>
          <li>{t("privacy_policy17")}</li>
          <li>{t("privacy_policy18")}</li>
        </ul>
      </div>
      <div className="mt-10 mb-10 font-bold text-xl">
        {t("privacy_policy19")}
      </div>
      <div>{t("privacy_policy20")}</div>
      <div>{t("privacy_policy21")}</div>
      <div className="mt-10 mb-10 font-bold text-xl">
        {t("privacy_policy22")}
      </div>
      <div>{t("privacy_policy23")}</div>
      <div className="mt-10 mb-10 font-bold text-xl">
        {t("privacy_policy24")}
      </div>
      <div className="mb-10">{t("privacy_policy25")}</div>
    </div>
  );
};
export default PrivacyPolicy;
